import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t border-white/10 bg-charcoal pb-16" data-id="element-78" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-79" data-mp="32nukolv2nz0b">
        <p className="text-xs leading-snug text-white/60" data-id="element-80" data-mp="32pp57z2flp3v">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-xs leading-snug text-white/60" data-id="element-81" data-mp="36n3axgqwler4">
          {PRODUCT_NAME}™ es un producto educativo. No sustituye formación
          profesional, práctica supervisada, manuales de fabricantes, normas de
          seguridad, requisitos de instalación ni el criterio de un profesional
          competente. El uso de herramientas, los cortes, las perforaciones, las
          fijaciones y la instalación de muebles deben realizarse siguiendo las
          medidas de seguridad aplicables.
        </p>
        <p className="mt-1.5 text-xs text-white/80" data-id="element-82" data-mp="2ey09e8qeiii6">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-cta transition-colors duration-150 ease-out hover:text-white" data-id="element-83" data-mp="2evx8uurmh6z7">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white/80" data-id="element-84" data-mp="3v7gbtq7xxs4j">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-cta" data-id="element-85" data-mp="3qazp90ge3ltk">
            Términos y Condiciones
          </a>
          <span className="text-white/40" data-id="element-86" data-mp="33noucq2vvnv">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-cta" data-id="element-87" data-mp="htd4fcyx427o">
            Política de Privacidad
          </a>
          <span className="text-white/40" data-id="element-88" data-mp="qt8grl47m39a">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-cta" data-id="element-89" data-mp="qu1ejwl6xifa">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}